export const getTabs = (): { label: string; name: string }[] => {
  return [
    { label: "Wszystkie", name: "all" },
    { label: "W trakcie", name: "in-progress" },
    { label: "Spodziewane", name: "not-started" },
    { label: "Zakończone", name: "finished" },
  ];
};
